import * as React from 'react';

export interface Props {
    number: number;
    size?: 'large';
    positiveSign: string;
    negativeSign: string;
    isModified: boolean;
    className: string;
    isDarkMode?: boolean;
}

export default class SignedNumber extends React.PureComponent<Props> {
    static defaultProps = {
        positiveSign: '+',
        negativeSign: '-',
        isModified: false,
        className: '',
    };

    render() {
        const { number, positiveSign, negativeSign, size, isModified, className, isDarkMode } = this.props;

        let classNames: Array<string> = ['ddbc-signed-number', className];
        if (isModified) {
            classNames.push('ddbc-signed-number--modified');
        }
        if (size) {
            classNames.push(`ddbc-signed-number--${size}`);
        }

        return (
            <span className={classNames.join(' ')}>
                <span className={`ddbc-signed-number__sign ${isDarkMode ? 'ddbc-signed-number__sign--dark-mode' : ''}`}>
                    {number >= 0 ? positiveSign : negativeSign}
                </span>
                <span
                    className={`ddbc-signed-number__number ${
                        isDarkMode ? 'ddbc-signed-number__number--dark-mode' : ''
                    }`}
                >
                    {Math.abs(number)}
                </span>
            </span>
        );
    }
}
